<ndt-global-search-view
   [accountSearchCallState]="accountSearchCallState$ | async"
   [accountSearchResults]="accountSearchResults$ | async"
   [deviceSearchCallState]="deviceSearchCallState$ | async"
   [deviceSearchResults]="deviceSearchResults$ | async"
   [phoneNumberSearchCallState]="phoneNumberSearchCallState$ | async"
   [phoneNumberSearchResults]="phoneNumberSearchResults$ | async"
   [softphoneUsernameSearchCallState]="softphoneUsernameSearchCallState$ | async"
   [softphoneUsernameSearchResults]="softphoneUsernameSearchResults$ | async"
   (completed)="onItemSelected()"
   (clickedInside)="handleClickInsideSearch($event)"
></ndt-global-search-view>
